

<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
      <div class="gc-login-container vx-col QQsm:w-1/2 QQmd:w-1/2 QQlg:w-3/4 QQxl:w-3/5 QQsm:m-0 m-4">
      <vx-card class="gc-login-card no-bg">
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter QQjustify-center justify-end items-center">

<!--            <div class="vx-col hidden lg:block lg:w-1/2">-->
<!--              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">-->
<!--            </div>-->

            <div class="vx-col xsm:w-full xmd:w-full xlg:w-1/2 d-theme-dark-bg gc-login-form">
              <div class="px-8 pt-8 login-tabs-container" style="height:400px">

<!--                  <div class="head-bg-img">-->
<!--                      <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">-->
<!--                  </div>-->

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">找回密码</h4>
<!--                  <p>欢迎登录</p>-->
                </div>

                <div class="vx-card__title mb-4" style="margin-top:40px;">
                    <gc-login-recover-password-form />
                </div>

                <div class="justify-center items-center vx-card__title mb-4 bottom-logo" >
<!--                  <img src="https://intab.oss-cn-beijing.aliyuncs.com/static/gcloud/2020/v-1.0/logo.2.128px.png" />-->
<!--                  <span>群小云</span>-->
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>
// import LoginJwt from './LoginJWT.vue'
import GcLoginRecoverPasswordForm from "./RecorverPassword.Form";
// import LoginFirebase from './LoginFirebase.vue'
// import LoginAuth0 from './LoginAuth0.vue'

export default {
  components: {
      GcLoginRecoverPasswordForm,
    // LoginJwt
    // LoginFirebase,
    // LoginAuth0
  }
}
</script>

<style lang="scss">
.login-tabs-container {
  /*min-height: 505px;*/

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
.bottom-logo {
  // position: absolute;

  // bottom: 0;

  display: flex;
  align-items: center;
  color: rgba(52,147,228,1);

  margin-top: 100px;
  // border:1px solid red;
  text-align: center;
  // width: 100px;
  // margin: 0 auto;
  // display: block;

  img {
    width: 30px;
    margin-right: 4px;
  }
}


.gc-login-form {
    min-width: 200px;
    /*max-width: 600px;*/
    /*background: url(../../../assets/images/pages/login.png) no-repeat fixed;*/
    /*background-size: contain;*/
}

.vx-card.no-bg {
    background: none;
    box-shadow: none;
    .full-page-bg-color {
        background: none;
    }
}

.layout--full-page .bg-img {
    background-image: url("https://customer-public-resources.oss-cn-zhangjiakou.aliyuncs.com/web/images/yooz/yz-bg.1.flip-h.2.jpg");

}

.gc-login-container {
    width: 85%;
    .gc-login-form {
        max-width: 360px;
    }
}

</style>
